import "./core/init.mjs"
// import "./test-mapclient.mjs"
// import "./test-mapclient2.mjs"
//import "./test1.mjs"
//import "./test-schoolselector.mjs"

/**
 * Test Services 
 */
//import "./unit-test/test-itinerarygroup.mjs"
//import "./unit-test/test-itinerarygrouppreprocessor.mjs"
//import "./unit-test/test-itinerarygroupprocessor.mjs"

/**
 * Test DataSources 
 */
//import "./datasources/test-bansource.mjs"
//import "./datasources/test-indexsource.mjs"
//import "./datasources/test-stopsource.mjs"

/**
 * Test components 
 */

//import "./components/test-suggestionlist.mjs"
//import "./components/test-schedulecomponent.mjs"
//import "./components/test-scheduletablecomponent.mjs"
//import "./components/test-schedulescomponent.mjs"
//import "./components/test-view.mjs"
//import "./components/test-stoptag.mjs"
//import "./components/test-inband.mjs"
// import "./components/test-map.mjs"
//import "./components/test-stoplist.mjs";
//import "./components/test-searchbar.mjs";


/**
 * Test controllers
 */
//import "./controllers/test-scheduleviewer.mjs";
// import "./controllers/test-destineoplanner.mjs"
//import "./controllers/test-stopselector.mjs"
// import "./controllers/test-controllermanager.mjs"
import "./controllers/test-controllermanager2.mjs"